import LoadScript from "../utils/LoadScript";

export default class BlockMovie {

	static init() {
		this.playerYoutube = document.querySelectorAll('.player-youtube');
		this.playerVimeo = document.querySelectorAll('.player-vimeo');

		if (this.playerYoutube.length > 0) {
			LoadScript.load('https://www.youtube.com/iframe_api', this.initPlayerYoutube.bind(this));

			document.addEventListener("gdpr_settings_changed", (e) => {
				this.initPlayerYoutube(true);
			});
		}

		if (this.playerVimeo.length > 0) {
			LoadScript.load('https://player.vimeo.com/api/player.js', this.initPlayerVimeo.bind(this));

			document.addEventListener("gdpr_settings_changed", (e) => {
				this.initPlayerVimeo(true);
			});
		}

		this.initAutoplayModal();
	}

	static verifyCookieStatus() {
		if (document.body.classList.contains("no-cc")) {
			// Si le module RGPD n'est pas actif, on simule que les cookie videos sont acceptés
			return 1;
		}


		function getCookie(name) {
			const cookies = document.cookie.split("; ");



			for (let cookie of cookies) {
				const [cookieName, cookieValue] = cookie.split("=");
				if (cookieName === name) {
					return decodeURIComponent(cookieValue); // Décoder la valeur encodée
				}
			}
			return null;
		}

		function parseGdprCookie(cookieValue) {
			if (!cookieValue) {
				return null;
			}

			const decodedValue = cookieValue.replace(/%3A/g, ":");

			const pairs = decodedValue.split("!"); // Séparer les paires clé-valeur
			const result = {};

			pairs.forEach(pair => {
				const [key, value] = pair.split(":"); // Séparer clé et valeur
				if (key && value !== undefined) {
					result[key] = value;
				}
			});

			return result;
		}

		const cookieValue = getCookie("gdpr_cookie");

		const parsedCookie = parseGdprCookie(cookieValue);
		console.log(">> Consentement social : ", parsedCookie.social);

		if (cookieValue) {
			const parsedCookie = parseGdprCookie(cookieValue);

			return parseInt(parsedCookie.social);
		}
	}

	static initPlayerYoutube(gdpr_settings_changed = false) {
		this.playerYoutube.forEach((youtube) => {
			let el = youtube;
			let videoID = el.dataset.videoId;
			let player = el.closest('.movie');

			if (!player.querySelector('img')) {
				let poster = "https://img.youtube.com/vi/" + videoID + "/maxresdefault.jpg";
				let img = document.createElement('img');
				img.src = poster;
				player.append(img);
			}

			let youtubePlayer = null;

			if (this.verifyCookieStatus() !== 1) {
				player.classList.add("cookie-missing");
			} else {
				player.classList.remove("cookie-missing");

				if (gdpr_settings_changed) {
					player.classList.add("gdpr-settings-changed");
				}

				player.addEventListener('click', (e) => {
					player.classList.add("loading");
					document.querySelectorAll(".movie").forEach(movie => {
						movie.classList.remove("gdpr-settings-changed");
					});

					const action = e.detail?.action || "not-in-modal";
					if (!player.classList.contains('player-load')) {
						youtubePlayer = new YT.Player(videoID, {
							height: '360',
							width: '640',
							videoId: videoID,
							playerVars: {
								'autoplay': 0,
								'showinfo': 0,
								'modestbranding': 1,
								'rel': 0,
								'enablejsapi': 1
							},
							events: {
								'onStateChange': (event) => {
									if (event.data === 1) {
										player.classList.remove("loading");
										player.classList.add('playing');
									}
								},
								'onReady': (event) => {
									player.classList.add('player-load');
									event.target.playVideo();
								}
							}
						});

					} else {

						if (action == "show") {
							youtubePlayer.playVideo();
						} else {
							youtubePlayer.pauseVideo();
						}
					}
				});
			}
		});
	}

	static initPlayerVimeo(gdpr_settings_changed = false) {
		this.playerVimeo.forEach((vimeo) => {
			let el = vimeo;
			let videoID = el.dataset.videoId;
			let url = el.dataset.videoUrl;
			let player = el.closest('.movie');

			// if (!player.querySelector('img')) {
			// 	const xhttp = new XMLHttpRequest();
			// 	xhttp.onload = function () {
			// 		let poster = xhttp.response.thumbnail_url;
			// 		if (poster) {
			// 			let img = document.createElement('img');
			// 			img.src = poster;
			// 			player.append(img);
			// 		}
			// 	};
			// 	xhttp.responseType = 'json';
			// 	xhttp.open("GET", 'https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(url), true);
			// 	xhttp.send();
			// }

			let playerVimeo = null;

			console.log(this.verifyCookieStatus());

			if (this.verifyCookieStatus() !== 1) {

				player.classList.add("cookie-missing");
			} else {
				player.classList.remove("cookie-missing");

				if (gdpr_settings_changed) {
					player.classList.add("gdpr-settings-changed");
				}

				player.addEventListener('click', (e) => {
					player.classList.add("loading");
					document.querySelectorAll(".movie").forEach(movie => {
						movie.classList.remove("gdpr-settings-changed");
					});

					const action = e.detail?.action || "not-in-modal";


					if (!player.classList.contains('player-load')) {
						playerVimeo = new Vimeo.Player(videoID, {
							url: url
						});

						playerVimeo.on("play", () => {
							player.classList.remove("loading");
							player.classList.add('playing');
						});

						playerVimeo.on("loaded", () => {
							player.classList.add('player-load');
							// const closestMovie = player.closest(".movie");
							// playerVimeo.getVideoWidth().then(width => {
							//     playerVimeo.getVideoHeight().then(height => {
							//         closestMovie.style.aspectRatio = width/height; // Applique le style
							//     });
							// });

							playerVimeo.play();
						});

					} else {
						if (action == "show") {
							playerVimeo.play();
						} else {
							playerVimeo.pause();
						}
					}
				});
			}
		});
	}

	static initAutoplayModal() {
		let modalMovie = document.querySelectorAll('.modal-movie');
		modalMovie.forEach((modal) => {
			modal.addEventListener('shown.bs.modal', event => {
				const movieElement = event.target.querySelector('.modal-video .movie');
				const customClick = new CustomEvent('click', { detail: { action: 'show' } });
				movieElement.dispatchEvent(customClick);
			});
			modal.addEventListener('hide.bs.modal', event => {
				const movieElement = event.target.querySelector('.modal-video .movie');
				const customClick = new CustomEvent('click', { detail: { action: 'hide' } });
				movieElement.dispatchEvent(customClick);
			});
		});
	}
}
